import { useEffect, useState } from 'react';
import {
  InboxIcon,
  PersonIcon,
  StarOutline,
  Vivier,
} from '../../../../assets/icons';
import SidebarUnitDesktop from '../../components/SidebarUnitDesktop';

const VivierTaleez = () => {
  const [vivierExpanded, setVivierExpanded] = useState(
    localStorage.getItem('vivier-expanded') === 'true'
  );
  // Every page mounts its own sidebar: the sub-items only slide in when they
  // are opened here, not each time a page restores them open.
  const [wasToggled, setWasToggled] = useState(false);
  const subItemClassName = wasToggled ? 'motion-safe:animate-expandIn' : '';

  useEffect(() => {
    localStorage.setItem('vivier-expanded', vivierExpanded);
  }, [vivierExpanded]);

  return (
    <>
      <SidebarUnitDesktop 
        routeName={'Viviers'} 
        routeSidebar={null}
        icon={Vivier}
        text="Viviers"
        activePatterns={['/vivier', '/listAllVivier', '/ficheVivier', '/vivier-rating-temp-worker']}
        expandOnly={true}
        onExpandClick={() => {
          setWasToggled(true);
          setVivierExpanded(!vivierExpanded);
        }}
      />
      {vivierExpanded && (
        <>
          <SidebarUnitDesktop
            routeName={'Candidats'}
            routeSidebar={'/vivier'}
            icon={PersonIcon}
            iconColor="#374151"
            text="Candidats"
            isSubItem={true}
            className={subItemClassName}
            exactMatch={true}
          />
          <SidebarUnitDesktop
            routeName={'Tous les viviers'}
            routeSidebar={'/listAllVivier'}
            icon={InboxIcon}
            iconColor="#374151"
            text="Tous les viviers"
            isSubItem={true}
            className={subItemClassName}
          />
          <SidebarUnitDesktop
            routeName={'Avis'}
            routeSidebar={'/vivier-rating-temp-worker/rating-untreated'}
            icon={StarOutline}
            iconColor="#374151"
            text="Avis"
            isSubItem={true}
            className={subItemClassName}
          />
        </>
      )}
    </>
  );
};

export default VivierTaleez;
